import React, {useState, useEffect} from 'react';
import {DialogContent, DialogTitle} from '@material-ui/core';
import {Dialog} from "../../styles/config";
import CircularIntegration from "../../widgets/CircularIntergration";
import Swal from "sweetalert2";
import Resource from "../../crud/resource";
import Form from "./form";
import Translate from "../../utils/utils";
import {getTranslation} from "../settings/translations/list";
import {useIntl} from "react-intl";

const Edit = ({handleCreate, handleUpdate, onCloseModal, moduleItem, languages, moduleName, isFlower, categories, groups}) => {

    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [initialValues, setInitialValues] = useState({});
    const [isSuccess, setIsSuccess] = useState(true);
    const moduleResource = new Resource(moduleName);
    const intl = useIntl();

    useEffect(() => {
        setOpen(moduleItem.id !== undefined);
        prepareLanguages(languages, moduleItem);

        if (!isCreatingResource()) {
            getUpdateData();
        }


    }, [moduleItem, languages]);

    const prepareLanguages = (languages, moduleItem) => {

        const values = {};
        const translations = moduleItem.translations ? moduleItem.translations : [];
        languages.forEach(language => {
            values[language.id] = '';
            translations.forEach(translation => {

                if (translation.language_id === language.id) {
                    values[language.id] = translation.name;
                }

            });
        });

        setInitialValues(values);
    }

    const getUpdateData = () => {
        setIsLoading(true);
        moduleResource.show(moduleItem.id, {'translations': true}).then(response => {
            const {data: {data = {data: []}}} = response;
            prepareLanguages(languages, data);
            setIsLoading(false);
        }).catch(error => {
            Swal.fire({
                icon: 'error',
                text: 'Error occurred'
            });
        });
    }

    const closeModal = () => {
        setOpen(false);
        const values = {};
        languages.forEach(language => {
            values[language.id] = '';
        });
        setInitialValues(values);
        onCloseModal();
    };

    const isCreatingResource = () => {
        return moduleItem.id === undefined;
    };

    const preparePayload = (data) => {
        return Object.entries(data).reduce((payload, [language_id, name]) => {
            if (isNaN(parseInt(language_id))) {
                payload[language_id] = name;
                return payload;
            }
            const {translations} = payload;
            translations.push({language_id, name});
            payload.translations = translations;
            return payload;
        }, {translations: []});
    }

    const createResource = (payload, {setStatus, setErrors, resetForm}) => {
        setIsLoading(true);
        return moduleResource.create(preparePayload(payload)).then(response => {
            const {data: {data = {data: []}}} = response;
            handleCreate(data);
            setIsLoading(false);
            setIsSuccess(true);
            resetForm();
            setStatus('Created Successfully');
        }).catch(error => {
            const {response: {data: {errors = [], message = ""} = {}}} = error;
            setIsSuccess(false);
            setErrors(errors);
            setStatus(message || 'Failed Try again');
            setIsLoading(false)
        });
    };

    const updateResource = (payload, {setStatus, setErrors}) => {
        setIsLoading(true);
        return moduleResource.update(preparePayload(payload), moduleItem.id).then(() => {
            const {group_id, category_id} = payload;
            handleUpdate(preparePayload(payload), group_id, category_id);
            setIsLoading(false);
            setIsSuccess(true);
            setStatus('Updated Successfully');
        }).catch(error => {
            const {response: {data: {errors = [], message = ""} = {}}} = error;
            setIsSuccess(false);
            setErrors(errors);
            setStatus(message || 'Failed Try again');
            setIsLoading(false)
        });
    };

    return (
        <div>
            <button className="btn btn-success btn-elevate kt-add-user__button  kt-login__btn-primary"
                    onClick={() => setOpen(true)}>
                <Translate id="DIALOG.BUTTON.ADD.TITLE"/>
            </button>
            <Dialog onClose style={{backgroundmoduleItem: 'rgba(43, 32, 43, 0.8)'}} onClose={closeModal}
                    aria-labelledby="customized-dialog-title" open={open}>
                <DialogTitle id="customized-dialog-title" onClose={closeModal}>
                    <div className="title__user-wrapper">
                        <div className="title__user-action">
                            <CircularIntegration done={!isLoading} load={isLoading}/>
                        </div>
                        <div className="title__user-title">
                            <h3>
                                {isCreatingResource() ? <Translate id={"DIALOG.BUTTON.ADD.TITLE"}/> :
                                    <Translate id={"TABLE.ACTIONS.EDIT"}/>} {intl.formatMessage({id: getTranslation(moduleName)})}
                            </h3>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent dividers>
                    <Form initialValues={initialValues} createResource={createResource} updateResource={updateResource}
                          isCreatingResource={isCreatingResource} closeModal={closeModal} languages={languages}
                          isLoading={isLoading} isSuccess={isSuccess} isFlower={isFlower} categories={categories}
                          groups={groups} moduleItem={moduleItem} moduleName={moduleName}/>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default Edit;
